import { isManager } from "@/context/AuthContext";

// Zrcadlí tasks.py:complete_task — kdyby se pravidlo měnilo, měnit obojí.
// Kdo schvaluje, ten schválení nepotřebuje; vlastní úkol nemá kdo schválit.
export const closesWithoutApproval = (task, user) =>
  isManager(user) ||
  (task?.created_by === user?.id && (task?.assignees || []).every((a) => a === user?.id));
